<template>
  <div id="func-4" :class="densidadeClass">
    <div v-if="!apenasGuiaImpresso" class="header">
      <FuncionalidadeHeader
        :titulo="`Busca de ${funcParametros.dashboard.nome}`"
        :voltar="!isWidget"
      />
    </div>

    <div class="content">
      <Func4BuscaRedeCredenciada v-if="!apenasGuiaImpresso" :getGeolocation="getGeolocation" :changeFilters="filters"/>

      <div class="listagem-wrapper">
        <div class="line"></div>
        <Func4RedeCredenciadaEmpty v-if="showEmpty && !apenasGuiaImpresso && !showGuiaImpresso" :getGeolocation="getGeolocation" />
        <Func4GuiaImpresso v-if="showGuiaImpresso || apenasGuiaImpresso"/>
        <Func4RedeCredenciadaListagem v-show="!showDetalhe && !showEmpty && !showGuiaImpresso" @changeFilters="onChangeFilters" />
        <Func4Detalhe v-if="showDetalhe" v-show="!showGuiaImpresso" />
      </div>
    </div>
  </div>
</template>

<script>

import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import Func4BuscaRedeCredenciada from '@/views/4/BuscaRedeCredenciada'
import Func4RedeCredenciadaListagem from '@/views/4/RedeCredenciadaListagem'
import Func4Detalhe from '@/views/4/Detalhe'
import { mapActions, mapGetters, mapState } from 'vuex'
import Func4RedeCredenciadaEmpty from '@/views/4/RedeCredenciadaEmpty'
import { EnumGeolocationPermissionState } from '@/constants/EnumsRedeCredenciada'
import Func4GuiaImpresso from '@/views/4/GuiaImpresso.vue'

export default {
  name: 'Func4RedeCredenciada',
  components: {
    FuncionalidadeHeader,
    Func4BuscaRedeCredenciada,
    Func4RedeCredenciadaEmpty,
    Func4RedeCredenciadaListagem,
    Func4Detalhe,
    Func4GuiaImpresso
  },
  data () {
    return {
      filters: {}
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'json', 'frameId']),
    ...mapGetters('SetupApp', ['isWidget']),
    ...mapState('RedeCredenciada', [
      'densidade',
      'showEmpty',
      'showGuiaImpresso',
      'apenasGuiaImpresso',
      'showDetalhe',
      'geolocalizacao',
      'permiteGeolocalizacao',
      'solicitaGeolocalizacaoNoCarregamento'
    ]),
    ...mapGetters('RedeCredenciada', ['prestador']),
    densidadeClass () {
      return 'densidade-' + this.densidade
    },
    funcParametros () {
      return this.funcionalidade.parametros
    }
  },
  methods: {
    ...mapActions('RedeCredenciada', ['setViewDetalhe', 'setPrestador']),
    emitGetGeolocation () {
      const payload = {
        origin: 'omnichannel',
        client: this.frameId,
        type: 'command',
        command: 'GET_GEOLOCATION',
        data: {},
        timestamp: Date.now()
      }
      window.parent.postMessage(payload, '*')
    },
    getGeolocation () {
      if (!this.geolocalizacao.lat && !this.geolocalizacao.lng && this.permiteGeolocalizacao &&
        (this.geolocalizacao.permissionState === EnumGeolocationPermissionState.PROMPT ||
          this.geolocalizacao.permissionState === EnumGeolocationPermissionState.GRANTED)) {
        this.emitGetGeolocation()
      }
    },
    onChangeFilters (filters) {
      this.filters = filters
    }
  },
  created () {
    if (this.$route.query.detalhe) {
      this.setPrestador(this.prestador)
      this.setViewDetalhe(true)
    }
  }
}

</script>

<style scoped lang="less">
.content {
  display: flex;
  flex-flow: row;
  border-top: 1px solid lightgray;
}

.densidade-1, .densidade-2, .densidade-3 {
  .header,
  .listagem-wrapper {
    display: none;
  }
}

.listagem-wrapper {
  flex: 1;
  height: 100%;
  overflow: auto;
  border-left: 1px solid #EEEEEE;
  width: 100%;
}
</style>
